import { isClient } from '@vueuse/core'
import { AppUtils } from '@/utils/appUtils'
import { TokenKey } from '@/utils/auth'
import { getFirstDomain } from '@/utils'
import { Locale as VantLocale } from 'vant'
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US'
// 引入英文语言包
import zhCN from 'vant/es/locale/lang/zh-CN'

// 创建 AppUtils 实例
let appUtils = null
let flag = 0
if (isClient) {
  appUtils = new AppUtils()
}

const hasLanguagePrefix = (path: string) => {
  return /^\/(en|cn)\//.test(path)
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  console.log('running global auth middleware.', to.fullPath)
  const { $i18n } = useNuxtApp()
  const mySystemStore = useMySystemStore()
  const { public: PublicConfig } = useRuntimeConfig()

  mySystemStore.setProxyApi(PublicConfig.PROD_CLIENT_PROXY_API)
  const { finish } = useLoadingIndicator()
  if (
    to.params &&
    to.params.lang &&
    (to.params.lang === 'cn' || to.params.lang === 'en')
  ) {
    const lang = to.params.lang === 'en' ? 'en-US' : 'zh-CN'
    const vantLcolae = to.params.lang === 'en' ? enUS : zhCN
    $i18n.setLocale(lang)
    VantLocale.use(lang, vantLcolae)
    mySystemStore.setLanguage(lang)
    mySystemStore.setTargetPageCode(
      (to.meta.pageCode as unknown as string) ?? '',
    )
  } else if (!hasLanguagePrefix(to.path)) {
    const currentLang = mySystemStore.language === 'en-US' ? 'en' : 'cn'
    return navigateTo(`/${currentLang}${to.fullPath}`)
  }
  const { changeHeaderIsWhite, changeNoHeader, changeAppFlag } =
    useMySystemStore()

  if (appUtils?.isApp) {
    changeAppFlag(true)
  }
  if (to.meta?.headerIsWhite) {
    changeHeaderIsWhite(true)
  } else {
    changeHeaderIsWhite(false)
  }
  if (to.meta?.noHeader) {
    changeNoHeader(true)
  } else {
    changeNoHeader(false)
  }

  if (isClient) {
    // 每次进入页面之前先关闭header弹出层
    mySystemStore.closeHeaderPopup()
    if (!flag) {
      if (!to.query?.exchange) {
        await setAppConfig()
      } else {
        flag++
      }
    }
    await setClientId()
    // 设置整合营销推广projectId
    setProjectId(to)
    setExchange(to)
    console.log(
      '🚀👋 ~ file: auth.global.ts:51 ~ defineNuxtRouteMiddleware ~ isClient:',
      isClient,
    )
  }

  setTimeout(() => {
    finish()
  }, 3000)
})
// app 跳转 至H5
const setAppConfig = async () => {
  try {
    if (!appUtils) {
      return
    }
    if (appUtils.isApp) {
      flag++
      const { changeAppConfig, changeAppFlag } = useMySystemStore()
      changeAppFlag(true)

      // get App跳转到H5获取并获取app的信息
      const getAppMsg = await appUtils.postMessage('getAppTokenAndLang', {})
      const appLang = getAppMsg?.lang // app语言
      const appToken = getAppMsg?.token // 登录的token
      const appLoginflag = getAppMsg?.loginflag //用户是否登录
      const appTerminalType = getAppMsg?.terminalType
      changeAppConfig({ appTerminalType, appToken })
    }
  } catch (err) {
    showDialog({
      title: '标题 Android IOS错误',
      message: err + '',
    }).then(() => {
      // on close
    })
  }
}
const setProjectId = (route: any) => {
  if (isClient) {
    const prjId = route?.query?.prjId || ''
    if (!_isEmpty(prjId)) {
      sessionStorage.setItem('prjId', prjId)
      delete route.query.prjId
    }
  }
}

const setExchange = async (route: any) => {
  const exchangeStr = route.query?.exchange
  const { setAuthExchange, logout } = useMySystemStore()
  const {
    getUserCompanyInfo,
    getPermsInfo,
    getJoinCompanyAudit,
    compInfo,
    resetUserCompInfo,
  } = useMyUserStore()

  // 先判断有没有exchange 有的话 通过exchange取回token 用于放到请求的header中请求用户信息
  if (exchangeStr) {
    const firstToken = useCookie(TokenKey, {
      path: '/',
      domain: getFirstDomain() ? (getFirstDomain() ?? undefined) : undefined,
    })
    const secondToken = useCookie(TokenKey)
    firstToken.value = null
    secondToken.value = null

    const exchange = exchangeStr as string
    setAuthExchange({
      code: exchange,
    }).then(async () => {
      // 必须要删除exchange 才行 否则会一直重定向会login页面
      const newQuery = omit(route.query, ['exchange'])
      navigateTo({ path: route.path, query: newQuery, replace: true })

      await nextTick()
    })
  }
  // 如果没有exchange了 判断是否有token
  else if (getToken()) {
    const newQuery = omit(route.query, ['exchange', 'prjId'])

    try {
      await getUserCompanyInfo()
      getPermsInfo()
      navigateTo({
        path: route.path,
        query: newQuery,
        replace: true,
        force: true,
      })
    } catch (error) {
      console.error(
        '❌ ~ file: auth.global.ts:39 ~ setExchange ~ 获取用户信息失败:',
        error,
      )

      if (route.meta.needToken) {
        logout().then(() => {
          const localePath = useLocalePath()
          navigateTo(localePath('/'))
        })
      } else {
        navigateTo({
          path: route.path,
          query: newQuery,
          replace: true,
          force: true,
        })
      }
    } finally {
      if (!compInfo?.compId) {
        getJoinCompanyAudit()
      }
    }
  }
  // 没有token也没有exchange还不是白名单时， 跳转到passport登录页 取exchange去
  else if (route.meta.needToken) {
    go2LoginPage(route.path)
  }
  // 如果处于白名单中 放行 但需要清除登录信息
  else {
    resetUserCompInfo()
  }
}
